import { RouterProvider } from 'react-router/dom';

import { GlobalErrorProvider } from './context/GlobalErrorContext';
import { QueryProvider } from './query/QueryProvider';
import { router } from './router';

export default function App() {
  return (
    <GlobalErrorProvider>
      <QueryProvider>
        <RouterProvider router={router} />
      </QueryProvider>
    </GlobalErrorProvider>
  );
}
